import { ExpandLess, ExpandMore, Videocam } from '@mui/icons-material';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import MenuItem from 'app/shared/layout/menus/menu-item';
import React from 'react';
import { Translate } from 'react-jhipster';

export interface ICameraMenuProps {
  isAuthenticated: boolean;
  isAdmin: boolean;
  isTransporterAdmin: boolean;
  index: number;
  onExpand: (index: number) => void;
  isExpanded: boolean;
  setOpen: (value: boolean) => void;
  drawerIsOpen: boolean;
}

export const CameraMenu = ({ isAuthenticated, isAdmin, isTransporterAdmin, index, onExpand, isExpanded, setOpen, drawerIsOpen }: ICameraMenuProps) => {
  if (!isAuthenticated || (!isAdmin && !isTransporterAdmin)) {
    return null;
  }

  return (
    <>
      <Tooltip title={drawerIsOpen ? '' : <Translate contentKey="global.menu.cam">Câmeras</Translate>} placement="right">
        <ListItemButton
          onClick={() => onExpand(index)}
          sx={{
            pl: { xs: '18px', md: '32px' },
            backgroundColor: isExpanded ? 'action.selected' : 'transparent',
          }}
        >
          <ListItemIcon>
            <Videocam />
          </ListItemIcon>
          <ListItemText
            primary={<Translate contentKey="global.menu.cam">Câmeras</Translate>}
            primaryTypographyProps={{ fontSize: '14px', fontWeight: isExpanded ? '600' : '400' }}
            sx={{ opacity: drawerIsOpen ? 1 : 0 }}
          />
          {isExpanded ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </Tooltip>

      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <List component="div" disablePadding onClick={() => setOpen(false)}>
          <MenuItem icon="video" to="/live-monitor">
            Ao Vivo
          </MenuItem>
          <MenuItem icon="play" to="/camera-playback">
            Playback
          </MenuItem>
          <MenuItem icon="video" to="/camera-event">
            <Translate contentKey="global.menu.entities.cameraEvent">Alertas</Translate>
          </MenuItem>
          {isAdmin && (
            <MenuItem icon="video" to="/camera-device">
              <Translate contentKey="global.menu.camera.devices">Dispositivos</Translate>
            </MenuItem>
          )}
        </List>
      </Collapse>
    </>
  );
};

export default CameraMenu;
